import { useState } from 'react';

const sections = [
  {
    number: '01',
    icon: 'ri-money-dollar-circle-line',
    title: '간병비 이체 방법',
    color: '#2E7D6B',
    bg: 'rgba(46,125,107,0.08)',
    summary: '보험가입자 본인이 간병인에게 직접 계좌이체해야 합니다.',
    items: [
      {
        icon: 'ri-bank-card-line',
        label: '직접 이체 필수',
        desc: '간병비는 반드시 보험가입자 본인 계좌에서 간병인 계좌로 직접 이체해야 합니다.',
        highlight: true,
      },
      {
        icon: 'ri-money-cny-circle-line',
        label: '1일 최소 10만원 이상',
        desc: '1일 간병비는 최소 10만원 이상으로 정산되어야 합니다. 가입 상품에 따라 금액이 상이할 수 있습니다.',
        highlight: true,
      },
      {
        icon: 'ri-time-line',
        label: '이체 시기',
        desc: '간병이 종료된 후 전체 간병기간에 대한 금액을 한 번에 이체하거나, 매일 이체하는 방식 모두 가능합니다.',
        highlight: false,
      },
      {
        icon: 'ri-file-text-line',
        label: '이체 내역 보관',
        desc: '이체 확인증 또는 이체 내역 캡처본을 반드시 보관해 두세요. 보험 청구 시 필수 제출 서류입니다.',
        highlight: false,
      },
    ],
  },
  {
    number: '02',
    icon: 'ri-edit-2-line',
    title: '간병일지 작성',
    color: '#1a6b5a',
    bg: 'rgba(26,107,90,0.08)',
    summary: '당사에서 제공하는 간병일지 양식을 매일 빠짐없이 작성해야 합니다.',
    items: [
      {
        icon: 'ri-download-2-line',
        label: '양식 수령',
        desc: '간병 시작 전 반드시 코리아케어러스에 연락하여 간병일지 양식을 수령하세요. 임의 양식은 인정되지 않을 수 있습니다.',
        highlight: true,
      },
      {
        icon: 'ri-calendar-check-line',
        label: '매일 작성',
        desc: '간병일지는 간병이 이루어진 날마다 빠짐없이 작성해야 합니다. 날짜·간병 내용·서명을 정확히 기재해 주세요.',
        highlight: false,
      },
      {
        icon: 'ri-user-smile-line',
        label: '간병인 서명',
        desc: '각 항목에 간병인의 서명 또는 날인이 반드시 포함되어야 합니다.',
        highlight: false,
      },
      {
        icon: 'ri-folder-open-line',
        label: '원본 보관',
        desc: '간병일지 원본은 퇴원 후 당사로 제출해야 합니다. 분실되지 않도록 주의 깊게 보관하세요.',
        highlight: false,
      },
    ],
  },
  {
    number: '03',
    icon: 'ri-hospital-line',
    title: '입퇴원 확인서 발급',
    color: '#2E7D6B',
    bg: 'rgba(46,125,107,0.08)',
    summary: '퇴원 시 병원에서 입퇴원확인서를 반드시 발급받으세요.',
    items: [
      {
        icon: 'ri-file-download-line',
        label: '퇴원 당일 발급',
        desc: '퇴원 당일 병원 원무과에서 입퇴원확인서를 발급받으세요. 나중에 재발급 시 수수료가 발생할 수 있습니다.',
        highlight: false,
      },
      {
        icon: 'ri-information-line',
        label: '기재 항목 확인',
        desc: '입퇴원확인서에는 입원일, 퇴원일, 병명(진단명), 담당의 서명이 모두 포함되어야 합니다.',
        highlight: true,
      },
      {
        icon: 'ri-send-plane-line',
        label: '제출 방법',
        desc: '발급받은 입퇴원확인서를 코리아케어러스 카카오 채팅방 또는 팩스(070-7862-8654)로 전송해 주세요.',
        highlight: false,
      },
    ],
  },
  {
    number: '04',
    icon: 'ri-send-plane-line',
    title: '서류 제출 방법',
    color: '#1a6b5a',
    bg: 'rgba(26,107,90,0.08)',
    summary: '간병 종료 후 아래 서류를 코리아케어러스로 제출해야 합니다.',
    items: [
      {
        icon: 'ri-checkbox-circle-line',
        label: '제출 서류 목록',
        desc: '① 입퇴원확인서  ② 간병비 이체 내역  ③ 간병일지 — 세 가지 서류를 모두 제출해야 합니다.',
        highlight: true,
      },
      {
        icon: 'ri-chat-smile-2-line',
        label: '카카오 채팅방 전송',
        desc: '서류를 스마트폰으로 촬영하거나 스캔하여 코리아케어러스 카카오톡 채팅방으로 전송해 주세요.',
        highlight: false,
      },
      {
        icon: 'ri-printer-line',
        label: '팩스 전송',
        desc: '팩스 전송도 가능합니다. 팩스번호: 070-7862-8654',
        highlight: false,
      },
      {
        icon: 'ri-timer-line',
        label: '제출 기한',
        desc: '퇴원 후 가능한 빠른 시일 내에 제출해 주세요. 늦어질수록 보험금 청구 일정이 지연될 수 있습니다.',
        highlight: false,
      },
    ],
  },
  {
    number: '05',
    icon: 'ri-error-warning-line',
    title: '주의 및 금지사항',
    color: '#c0392b',
    bg: 'rgba(192,57,43,0.08)',
    summary: '아래 사항을 위반하면 보험금 청구가 거절될 수 있습니다.',
    items: [
      {
        icon: 'ri-close-circle-line',
        label: '소급 적용 불가',
        desc: '가족간병 등록 전 발생한 간병비는 소급 적용이 절대 불가합니다. 입원 전 또는 당일에 반드시 등록하세요.',
        highlight: true,
      },
      {
        icon: 'ri-close-circle-line',
        label: '현금 지급 불가',
        desc: '간병비를 현금으로 지급하면 이체 내역이 남지 않아 보험 청구 시 인정받을 수 없습니다.',
        highlight: true,
      },
      {
        icon: 'ri-close-circle-line',
        label: '제3자 이체 불가',
        desc: '가족·지인 계좌를 통한 이체는 인정되지 않습니다. 반드시 보험가입자 본인 계좌에서 직접 이체해야 합니다.',
        highlight: true,
      },
      {
        icon: 'ri-close-circle-line',
        label: '무단 양식 사용 불가',
        desc: '코리아케어러스가 제공한 공식 간병일지 양식 이외의 임의 양식으로 작성된 간병일지는 인정되지 않을 수 있습니다.',
        highlight: false,
      },
    ],
  },
];

export default function EssentialItems() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="w-full py-14 bg-white">
      <div className="max-w-5xl mx-auto px-6">

        {/* 섹션 타이틀 */}
        <div className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-1">간병인 배정 후 체크리스트</h2>
          <p className="text-sm text-gray-500">항목을 클릭하면 상세 내용을 확인할 수 있습니다.</p>
        </div>

        <div className="space-y-4">
          {sections.map((sec, idx) => {
            const isOpen = openIndex === idx;
            const isWarning = sec.color === '#c0392b';
            return (
              <div
                key={idx}
                className="rounded-2xl border overflow-hidden transition-all duration-200"
                style={{
                  borderColor: isOpen
                    ? sec.color
                    : isWarning
                    ? 'rgba(192,57,43,0.2)'
                    : 'rgba(46,125,107,0.12)',
                  backgroundColor: '#fafffe',
                }}
              >
                {/* Accordion header */}
                <button
                  className="w-full flex items-center gap-4 px-6 py-5 text-left cursor-pointer hover:opacity-90 transition-opacity"
                  onClick={() => toggle(idx)}
                >
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-2xl font-black text-white text-sm flex-shrink-0"
                    style={{ backgroundColor: sec.color }}
                  >
                    {sec.number}
                  </div>
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ backgroundColor: sec.bg }}
                  >
                    <i className={`${sec.icon} text-base`} style={{ color: sec.color }}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-base font-bold text-gray-900">{sec.title}</p>
                    <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{sec.summary}</p>
                  </div>
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                    <i
                      className={`ri-arrow-down-s-line text-xl transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                      style={{ color: sec.color }}
                    ></i>
                  </div>
                </button>

                {/* Accordion body */}
                {isOpen && (
                  <div
                    className="px-6 pb-6 pt-2 border-t"
                    style={{ borderColor: 'rgba(46,125,107,0.08)' }}
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {sec.items.map((item, i) => (
                        <div
                          key={i}
                          className="rounded-xl p-4"
                          style={{
                            backgroundColor: item.highlight
                              ? isWarning
                                ? 'rgba(192,57,43,0.06)'
                                : 'rgba(46,125,107,0.06)'
                              : '#f9f9f9',
                            border: item.highlight
                              ? `1px solid ${isWarning ? 'rgba(192,57,43,0.2)' : 'rgba(46,125,107,0.15)'}`
                              : '1px solid rgba(0,0,0,0.05)',
                          }}
                        >
                          <div className="flex items-center gap-2 mb-1.5">
                            <div
                              className="w-6 h-6 flex items-center justify-center rounded-lg flex-shrink-0"
                              style={{ backgroundColor: sec.bg }}
                            >
                              <i className={`${item.icon} text-xs`} style={{ color: sec.color }}></i>
                            </div>
                            <p className="text-sm font-bold text-gray-800">{item.label}</p>
                            {item.highlight && (
                              <span
                                className="text-[10px] font-bold px-1.5 py-0.5 rounded-full ml-auto"
                                style={{
                                  backgroundColor: isWarning ? 'rgba(192,57,43,0.1)' : 'rgba(46,125,107,0.1)',
                                  color: sec.color,
                                }}
                              >
                                {isWarning ? '위반 금지' : '필수'}
                              </span>
                            )}
                          </div>
                          <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
